import type { Environments } from '@paddle/paddle-js';

export type PaddleClientConfig = {
  token: string;
  environment: Environments;
};

export function readPaddleClientConfig(): PaddleClientConfig | undefined {
  const token = import.meta.env.VITE_PADDLE_CLIENT_TOKEN?.trim();
  const environment = import.meta.env.VITE_PADDLE_ENVIRONMENT?.trim();
  if (!token) return undefined;
  if (environment !== 'sandbox' && environment !== 'production') {
    return undefined;
  }
  return { token, environment };
}

export function paddleClientConfig(): PaddleClientConfig {
  const token = import.meta.env.VITE_PADDLE_CLIENT_TOKEN?.trim();
  const environment = import.meta.env.VITE_PADDLE_ENVIRONMENT?.trim();
  if (!token) {
    throw new Error('VITE_PADDLE_CLIENT_TOKEN is unset');
  }
  if (environment !== 'sandbox' && environment !== 'production') {
    throw new Error(
      'VITE_PADDLE_ENVIRONMENT must be set to "sandbox" or "production"',
    );
  }
  return { token, environment };
}
